export default __webpack_public_path__ + "static/house2-704e9065a34bfcb4ae5bddb8b644001f.jpg";